"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APIconButton = _interopRequireDefault(require("../../common/APIconButton/APIconButton"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./MarginDepositWithdrawComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('margin-deposit-withdraw');
var MarginDepositWithdrawComponent = function MarginDepositWithdrawComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("margin"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
    iconName: "deposit",
    action: props.openMarginDepositModal,
    label: t("Deposit"),
    customClass: baseClasses('action-btn')
  }), /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
    iconName: "withdraw",
    action: props.openMarginWithdrawModal,
    label: t("Withdraw"),
    customClass: baseClasses('action-btn')
  }));
};
MarginDepositWithdrawComponent.propTypes = {
  openMarginDepositModal: _propTypes["default"].func.isRequired,
  openMarginWithdrawModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = MarginDepositWithdrawComponent;